import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-network-discovery',
  imports: [RouterModule, FeatureHero],
  templateUrl: './network-discovery.html',
  styleUrl: './network-discovery.scss',
})
export class NetworkDiscovery {

}
